import type { FC } from "react";
import { useCallback } from "react";
import type { ToastEntry } from "@UI/types/notifications.ts";
import DNotification from "@UI/components/Molecules/Notification/DNotification.tsx";

interface Props {
  entry: ToastEntry;
  onDismiss: (id: string) => void;
}

const DToastNotificationItem: FC<Props> = ({ entry, onDismiss }) => {
  const handleDismiss = useCallback(
    () => onDismiss(entry.id),
    [onDismiss, entry.id],
  );

  return (
    <DNotification
      label={entry.content}
      description={entry.description}
      state={entry.state}
      action={entry.action}
      size={entry.description ? "large" : "small"}
      style="floating"
      plain={entry.plain}
      onDismiss={entry.dismissible ? handleDismiss : undefined}
    />
  );
};

export default DToastNotificationItem;
